import { ChoiceSet } from "./assessmentsTypes";
import styles from "./CompanyAssessments.module.css";

interface MultipleChoiceAnswerFieldProps {
    groupName: string;
    choiceSet: ChoiceSet;
    value: string | undefined;
    onChange: (choiceId: string) => void;
    disabled?: boolean;
}

export function MultipleChoiceAnswerField({
    groupName,
    choiceSet,
    value,
    onChange,
    disabled = false
}: MultipleChoiceAnswerFieldProps) {
    return (
        <div>
            {choiceSet.choices.map(choice => (
                <label key={choice.id} className={styles.multipleChoiceOption}>
                    <input
                        type="radio"
                        name={groupName}
                        value={choice.id}
                        checked={value === choice.id}
                        disabled={disabled}
                        onChange={() => onChange(choice.id)}
                    />
                    <span>{choice.label}</span>
                </label>
            ))}
        </div>
    );
}
